import type { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '@simplywallst/ui-core';

interface Props {
  title: null | string;
  titleSuffix?: string;
  description?: string;
  allowCrawlers?: boolean;
  allowFollow?: boolean;
  children?: ReactNode;
  openGraphImageUrl?: string;
}

const DocumentHeader = ({
  allowCrawlers,
  allowFollow,
  title,
  titleSuffix,
  description,
  children,
  openGraphImageUrl,
}: Props) => {
  const theme = useTheme();
  const getRobotsContent = () => {
    if (allowCrawlers) return 'INDEX, FOLLOW';
    if (allowFollow) return 'NOINDEX, FOLLOW';
    return 'NOINDEX, NOFOLLOW';
  };

  return (
    <Helmet>
      <title>
        {`${title || ''}`}
        {titleSuffix ? ` ${titleSuffix}` : ''}
      </title>
      <meta property="title" content={`${title || ''} ${titleSuffix}`} />
      <meta property="og:title" content={`${title || ''} ${titleSuffix}`} />
      <meta property="og:locale" content="en_US" />
      <meta name="ROBOTS" content={getRobotsContent()} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Simply Wall St" />
      <meta content="Simply Wall St" itemProp="name" />
      <meta name="theme-color" content={theme.color.spaceGray} />
      {description && <meta name="description" content={description} />}
      {description && <meta name="og:description" content={description} />}
      {openGraphImageUrl && (
        <meta name="og:image" content={openGraphImageUrl} />
      )}
      {children}
    </Helmet>
  );
};

DocumentHeader.defaultProps = {
  titleSuffix: ' - Simply Wall St',
  allowCrawlers: false,
};

export default DocumentHeader;
